(() => {
  const bar = document.querySelector('[data-mobile-buy]');
  const submit = document.querySelector('.paper-product product-form [type="submit"]');
  if (!bar || !submit) return;
  const button = bar.querySelector('[data-mobile-submit]');
  const price = document.querySelector('.paper-product-price');
  const form = submit.closest('product-form');
  const mobile = matchMedia('(max-width: 700px)');
  let mainButtonVisible = false;
  let hasSeenButton = false;
  function sync() {
    const unavailable = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
    button.disabled = unavailable;
    button.textContent = submit.classList.contains('loading') ? 'Adding…' : 'Add to cart';
    bar.querySelector('[data-mobile-price]').textContent = price.innerText.trim();
    bar.querySelector('[data-mobile-choice]').textContent = form.querySelector('[data-dp95-purchase-option="framed"][aria-pressed="true"]') ? 'Original + custom frame' : '';
    const show = mobile.matches && hasSeenButton && !mainButtonVisible;
    bar.hidden = !show;
    document.body.classList.toggle('paper-has-mobile-buy', show);
  }
  button.addEventListener('click', () => { if (!button.disabled) submit.click(); });
  new MutationObserver(sync).observe(form, {subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled','aria-pressed','class']});
  new MutationObserver(sync).observe(price, {subtree:true,childList:true,characterData:true});
  new IntersectionObserver(entries => {mainButtonVisible = entries[0].isIntersecting;
    if (mainButtonVisible || entries[0].boundingClientRect.bottom <= 0) hasSeenButton = true;
    sync();}, {threshold:0}).observe(submit);
  mobile.addEventListener('change', sync);
  sync();
})();
